function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-563 -7377) translate(-246 7268) translate(809 109)"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 13,
  fill: "#BFC0C2",
  stroke: "#F9F9F9",
  strokeWidth: 14
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#000",
  d: "M30.142 18.898l1.166-2.718c1.278.938 2.939 1.43 4.6 1.43 1.214 0 1.997-.476 1.997-1.191-.032-1.987-7.348-.445-7.412-5.452-.032-2.543 2.252-4.514 5.463-4.514 1.917 0 3.834.477 5.191 1.542l-1.086 2.765c-1.246-.794-2.795-1.35-4.265-1.35-1.006 0-1.66.476-1.66 1.08.031 1.97 7.41.89 7.49 5.674 0 2.607-2.22 4.419-5.382 4.419-2.333.032-4.473-.525-6.102-1.685m46.402-3.687c-.607 1.064-1.725 1.716-2.939 1.716-1.869 0-3.386-1.51-3.386-3.37 0-1.859 1.517-3.369 3.386-3.369 1.214 0 2.348.652 2.94 1.717l3.242-1.796c-1.214-2.162-3.53-3.624-6.182-3.624-3.913 0-7.092 3.163-7.092 7.073 0 3.91 3.179 7.072 7.092 7.072 2.652 0 4.968-1.462 6.182-3.623l-3.243-1.796zm-32.809 5.117h4.057V.588h-4.057v19.74zM81.832.588v19.74h4.057v-5.912l4.808 5.912h5.175l-6.102-7.025 5.655-6.564h-4.952l-4.584 5.452V.572h-4.057v.016zM60.268 6.755V8.36c-.671-1.112-2.3-1.875-4.026-1.875-3.546 0-6.357 3.13-6.357 7.057 0 3.926 2.795 7.088 6.357 7.088 1.725 0 3.355-.778 4.026-1.875v1.605h4.057V6.77h-4.057v-.015zm0 8.471c-.575.97-1.805 1.685-3.163 1.685-1.87 0-3.387-1.51-3.387-3.37 0-1.859 1.518-3.369 3.387-3.369 1.358 0 2.588.747 3.163 1.749v3.305z",
  transform: "translate(55 8)"
}), React.createElement("path", {
  fill: "#36C5F0",
  d: "M8.737.159c-1.31 0-2.38 1.065-2.38 2.368s1.07 2.368 2.38 2.368h2.38V2.527c0-1.303-1.054-2.368-2.38-2.368m0 6.31H2.412c-1.31 0-2.38 1.065-2.38 2.368s1.07 2.368 2.38 2.368h6.341c1.31 0 2.38-1.065 2.38-2.368-.016-1.303-1.07-2.368-2.396-2.368",
  transform: "translate(55 8)"
}), React.createElement("path", {
  fill: "#2EB67D",
  d: "M23.8 8.837c0-1.303-1.07-2.368-2.38-2.368-1.31 0-2.38 1.065-2.38 2.368v2.368h2.38c1.31.016 2.38-1.049 2.38-2.368m-6.341 0V2.511c0-1.303-1.07-2.368-2.38-2.368-1.31 0-2.38 1.065-2.38 2.368v6.326c0 1.303 1.07 2.368 2.38 2.368 1.326.016 2.38-1.049 2.38-2.368",
  transform: "translate(55 8)"
}), React.createElement("path", {
  fill: "#ECB22E",
  d: "M15.079 23.857c1.31 0 2.38-1.065 2.38-2.368 0-1.304-1.07-2.368-2.38-2.368h-2.38v2.368c0 1.303 1.07 2.368 2.38 2.368m0-6.326h6.341c1.31 0 2.38-1.065 2.38-2.368s-1.07-2.368-2.38-2.368H15.08c-1.31 0-2.38 1.065-2.38 2.368s1.07 2.368 2.38 2.368",
  transform: "translate(55 8)"
}), React.createElement("path", {
  fill: "#E01E5A",
  d: "M.032 15.163c0 1.303 1.07 2.368 2.38 2.368 1.31 0 2.38-1.065 2.38-2.368v-2.368h-2.38c-1.326 0-2.38 1.065-2.38 2.368m6.341 0v6.326c0 1.303 1.07 2.368 2.38 2.368 1.31 0 2.38-1.065 2.38-2.368v-6.326c0-1.303-1.07-2.368-2.38-2.368-1.325 0-2.38 1.065-2.38 2.368",
  transform: "translate(55 8)"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 151,
    height: 40,
    viewBox: "0 0 151 40"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/integration-slack.814abd16.svg";
export { SvgComponent as ReactComponent };